import ItemId from 'owa-service/lib/contract/ItemId';
import LikeItemResponse from 'owa-service/lib/contract/LikeItemResponse';
import likeItemJsonRequest from 'owa-service/lib/factory/likeItemJsonRequest';
import likeItemRequest from 'owa-service/lib/factory/likeItemRequest';
import likeItem2Operation from 'owa-service/lib/operation/likeItem2Operation';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import RequestOptions from 'owa-service/lib/RequestOptions';

function createLikeItemRequest(itemId: ItemId, isUnlike: boolean) {
    const request = likeItemRequest({
        IsUnlike: isUnlike,
        ItemId: itemId,
    });

    return request;
}

export default function likeItemService(
    itemId: ItemId,
    isUnlike: boolean,
    requestOptions: RequestOptions
): Promise<LikeItemResponse> {
    const requestBody = createLikeItemRequest(itemId, isUnlike);

    return likeItem2Operation(
        likeItemJsonRequest({
            Header: getJsonRequestHeader(),
            Body: requestBody,
        }),
        requestOptions
    ).then(response => {
        const responseMessage: LikeItemResponse = response.Body;
        return responseMessage;
    });
}
